import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { api } from '../services/api';

export default function VerifyEmailPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState('');

useEffect(() => {
  let tag = document.querySelector('meta[name="robots"]');

  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute('name', 'robots');
    document.head.appendChild(tag);
  }

  tag.setAttribute('content', 'noindex, nofollow');

  return () => {
    tag.setAttribute('content', 'index, follow');
  };
}, []);

  useEffect(() => {
    const run = async () => {
      const token = searchParams.get('token');

      if (!token) {
        setMessage('Missing verification token.');
        setLoading(false);
        return;
      }

      try {
        const res = await api.verifyEmail(token);
        setSuccess(true);
        setMessage(res.message || 'Email verified successfully.');
      } catch (err) {
        setSuccess(false);
        setMessage(err.response?.data?.detail || 'Verification failed.');
      } finally {
        setLoading(false);
      }
    };

    run();
  }, [searchParams]);

  useEffect(() => {
  if (loading) {
    document.title = 'Verify Your Email';
  } else {
    document.title = success ? 'Email Verified' : 'Verification Failed';
  }
}, [loading, success]);

  return (

    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-white rounded-2xl border border-gray-200 p-6 text-center">
        {loading ? (
          <>
            <div className="w-8 h-8 border-2 border-amber-600 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
            <p className="text-gray-600">Verifying your email...</p>
          </>
        ) : (
          <>
            <h1 className="text-2xl font-bold text-gray-900 mb-3">
              {success ? 'Email Verified' : 'Verification Failed'}
            </h1>
            <p className="text-sm text-gray-600 mb-6">{message}</p>
            <button
              onClick={() => navigate('/login')}
              className="w-full bg-gray-900 text-white py-3 rounded-xl font-semibold hover:bg-amber-700 transition-colors"
            >
              Go to Sign In
            </button>
          </>
        )}
      </div>
    </div>

  );
}